export enum Environment {
  Local = 'Local',
  QA = 'QA',
  Prod = 'Prod',
}

export function getEnv(): Environment {
  const envValue = import.meta.env.REACT_APP_ENVIRONMENT?.toLowerCase();

  switch (envValue) {
    case 'qa':
      return Environment.QA;
    case 'prod':
      return Environment.Prod;
    default:
      return Environment.Local;
  }
}
